import { AppDomainConstant } from "../../app-domain.constant";

export class EscrutarApiConstant {
  static readonly BASE_URL_ESCRUTINIO: string = "api/v1/escrutinio/";

  static readonly ESCRUTAR: string = "escrutar/";

  static readonly PREMIO_LOTERIA: string = "premio-loteria/";

  static readonly URL_GET_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "filter/scrutinitys";

  static readonly URL_GET_ESCRUTINIO_DETALLE: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    "premio-loteria/result/lottery-prize-confirmation";

  static readonly URL_POST_EJECUTAR_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "execute-scrutiny";

  static readonly URL_GET_REVERSO_FILTRO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "filter/reverse";

  static readonly URL_GET_CONFIRMACION_FILTRO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "filter/confirmation";

  static readonly URL_POST_EJECUTAR_CONFIRMAR_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "execute-confirmation";

  static readonly URL_ACTUALIZAR_ESTADO_ESCRITINIO_CONF: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "confirmation/status";

  static readonly URL_GET_DETELLA_LOTERIA_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "filter/reverse-detail";

  static readonly URL_GET_DETALLE_REVERSO_LOTERIA_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.PREMIO_LOTERIA +
    "result/lottery-prize-reverse";

  static readonly URL_POST_DETELLA_REVERSO_ESCRUTINIO: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "rerverse-detail/save";

  static readonly URL_GET_REPORT_CONFIRM_SCRUTINY: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    this.ESCRUTAR +
    "filter/get-report-scrutiny-response";
  
  static readonly URL_GET_REVERSED_BY_PRODUCTS: string =
    AppDomainConstant.URI_GATEWAY +
    EscrutarApiConstant.BASE_URL_ESCRUTINIO +
    EscrutarApiConstant.ESCRUTAR +
    "filter/reversed-by-products";
}
